import ErrorBoundary from '@/components/ErrorBoundary';
import { DefaultComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { standaloneComponent } from 'modules/dynamic-components';
import { ReactNode } from 'react';
import { isArray, isArrayNotEmpty } from 'typesafe-utils';
import { List, ListProps } from './List';
import { ListItemProps } from './List.Item';

export interface StandaloneListProps extends StandaloneComponentProps {
  as?: ListProps['as'];
  items?: ReactNode[];
  options?: Omit<ListProps, 'as'> & {
    $item?: ListItemProps;
  };
}

export const StandaloneList: StandaloneComponent<StandaloneListProps> = ({ items, options, as = 'ul', ...props }) => {
  const { $item: itemProps, ...baseProps } = options ?? {};

  return (
    <ErrorBoundary>
      <List as={as} {...options} {...baseProps} {...props}>
        {isArray(items) &&
          isArrayNotEmpty(items) &&
          items.map((item, i) => (
            <List.Item key={i} {...itemProps}>
              {item}
            </List.Item>
          ))}
      </List>
    </ErrorBoundary>
  );
};

export const standalone = StandaloneList;

const DynamicStandaloneList = standaloneComponent('ContentList') as typeof StandaloneList;

const DefaultList: DefaultComponent = ({ type, data, meta, descendants }) => {
  return <DynamicStandaloneList items={data.items} as={data.tag} />;
};

export default DefaultList;
